//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ResizeSensor } from 'css-element-queries';
import { getColourInRange, getHslColourInRange } from '@/helpers/colour';
import { naturalSort } from '@/helpers/util';
import store from '@/store';
import { PALETTE_COLOURS } from '@/store/types/getters';
import { COLOURS } from '@/store/types/namespaces';

const CIRCLE_SIZE = 20;
const palette = `${COLOURS}/${PALETTE_COLOURS}`;

export default {
  name: 'DpFloorplan',
  props: {
    devices: { type: Array, default: () => [] },
    settings: { type: Object, default: () => ({}) },
    draggable: { type: Boolean, default: false },
    kpi: { type: Boolean, default: false },
  },
  data() {
    return {
      resizeSensor: null,
      imageSize: { width: 0, height: 0, scale: 0 },
      deviceData: [],
      unsetDevices: [],
      widgetCursorPosition: null,
      minimumColourValue: null,
      maximumColourValue: null,
      resetModalVisible: false,
    };
  },
  computed: {
    legendColours() {
      const { colouring } = this.settings;
      if (colouring) {
        const { start, end } = colouring;
        if (!start || !end) return null;
        return [start, end];
      }
      return null;
    },
    devicePoints() {
      return this.deviceData.map((d) => {
        const x = this.toScale(d.$x);
        const y = this.toScale(d.$y);

        return {
          ...d,
          $x: x,
          $y: y,
          tooltip: this.getDeviceTooltip(d),
        };
      });
    },
  },
  watch: {
    devices() {
      this.render();
    },
    settings() {
      this.render();
    },
  },
  mounted() {
    this.setImgInfo();
    // Listen to container resize events to prevent partial render:
    // https://github.com/Leaflet/Leaflet/issues/4835
    this.resizeSensor = new ResizeSensor(this.$el, this.setImgInfo);
    this.render();
  },
  methods: {
    showResetModal() {
      this.resetModalVisible = true;
    },
    hideResetModal() {
      this.resetModalVisible = false;
    },
    resetDevicesPos() {
      this.unsetDevices = naturalSort(this.unsetDevices
        .concat(this.deviceData.map((d) => ({ ...d, $x: null, $y: null }))), 'tooltip');
      this.deviceData = [];
      this.saveDevicePos(this.unsetDevices);
      this.hideResetModal();
    },
    handleDeviceSelection(e) {
      this.deviceData = this.deviceData
        .map((d) => ({ ...d, selected: d.$id !== e.target.dataset.device ? false : !d.selected }));

      if (this.deviceData.find((d) => d.selected)) {
        this.$emit('update-view-url', e.target.dataset.device);
      } else {
        this.$emit('update-view-url', null);
      }
    },
    moveWidget(e) {
      const imageOffset = this.$refs.image.getBoundingClientRect();

      this.$refs.unsetWidget.style.left = `${e.pageX - imageOffset.left - this.widgetCursorPosition.x}px`;
      this.$refs.unsetWidget.style.top = `${e.pageY - imageOffset.top - this.widgetCursorPosition.y}px`;
    },
    stopWidgetMove() {
      this.widgetCursorPosition = null;
    },
    initWidgetMove(e) {
      const widgetOffset = this.$refs.unsetWidget.getBoundingClientRect();

      this.widgetCursorPosition = {
        x: e.pageX - widgetOffset.left,
        y: e.pageY - widgetOffset.top,
      };
    },
    tooltipProperty() {
      const { tooltipProperty } = this.settings;
      return tooltipProperty || {
        field: '$id',
        format: (f) => f,
      };
    },
    getDeviceTooltip(d) {
      const tooltipProperty = this.tooltipProperty();
      const { colouring } = this.settings;

      const tooltip = d[tooltipProperty.field];

      if (this.kpi && d.$kpi) {
        return `${tooltip}<br>value: ${d.$kpi.value}`;
      }

      if (colouring && colouring.useColour && colouring.property) {
        const { property } = colouring;
        const value = d[property.name];

        return `${tooltip}<br>${property.alias}: ${value}`;
      }

      return tooltip;
    },
    getDeviceLabel(d) {
      const tooltip = this.getDeviceTooltip(d);
      return (tooltip && tooltip.split('<br>')[0]) || 'N/A';
    },
    toScale(x) {
      const { scale } = this.imageSize;

      return (x * scale) - (CIRCLE_SIZE / 2);
    },
    fromScale(x) {
      const { scale } = this.imageSize;

      return x / scale;
    },
    setImgInfo() {
      const { image } = this.$refs;
      const { $el } = this;

      if (!image || !$el) {
        return;
      }

      const imageRatio = image.naturalHeight / image.naturalWidth;
      const containerRatio = $el.clientHeight / $el.clientWidth;

      let width = 0;
      let height = 0;

      if (imageRatio < containerRatio) {
        width = $el.clientWidth;
        height = $el.clientWidth * imageRatio;
      } else if (imageRatio > containerRatio) {
        height = $el.clientHeight;
        width = $el.clientHeight / imageRatio;
      } else {
        width = $el.clientWidth;
        height = $el.clientHeight;
      }

      this.imageSize = {
        scale: image.clientWidth / image.naturalWidth,
        ratio: imageRatio * 100,
        height: Math.round(height),
        width: Math.round(width),
      };
    },
    dragStart(e) {
      e.dataTransfer.setDragImage(e.target, CIRCLE_SIZE / 2, CIRCLE_SIZE / 2);
      e.dataTransfer.setData('text/plain', e.target.dataset.device);
    },
    handleUnsetDrop(e) {
      e.preventDefault();
      if (this.draggable) {
        const device = e.dataTransfer.getData('text');
        const setDevice = this.deviceData.filter((d) => d.$id === device);

        if (setDevice) {
          this.deviceData = this.deviceData.filter((d) => d.$id !== device);
          this.unsetDevices = naturalSort(this.unsetDevices
            .concat(setDevice.map((d) => ({ ...d, $x: null, $y: null }))), 'tooltip');
          this.saveDevicePos(this.unsetDevices.filter((d) => d.$id === device));
        }
      }
    },
    handleDrop(e) {
      e.preventDefault();
      if (this.draggable) {
        const imageOffset = this.$refs.image.getBoundingClientRect();
        const device = e.dataTransfer.getData('text');
        const unsetDevice = this.unsetDevices.filter((d) => d.$id === device);

        if (unsetDevice) {
          this.unsetDevices = this.unsetDevices.filter((d) => d.$id !== device);
        }

        this.deviceData = this.deviceData
          .filter((d) => d.$id === device)
          .map((d) => ({
            ...d,
            $x: this.fromScale(e.pageX - imageOffset.left),
            $y: this.fromScale(imageOffset.bottom - e.pageY),
          }))
          .concat(this.deviceData.filter((d) => d.$id !== device))
          .concat(unsetDevice.map((d) => ({
            ...d,
            $x: this.fromScale(e.pageX - imageOffset.left),
            $y: this.fromScale(imageOffset.bottom - e.pageY),
          })));
        this.saveDevicePos(this.deviceData
          .filter((d) => d.$id === device)
          .map((d) => ({ ...d, $x: Math.round(d.$x), $y: Math.round(d.$y) })));
      }
    },
    saveDevicePos(device) {
      this.$emit('device-pos-updated', device);
    },
    calculateMarkerColour({ value, minimumValue, maximumValue }) {
      if (this.kpi) {
        return store.getters[palette][value];
      }

      const { colouring } = this.settings;
      if (!colouring || !colouring.useColour) {
        return store.getters[palette].primary;
      }

      const { start, end } = colouring;
      const { error, success } = store.getters[palette];

      const useHsl = start && start.substring(0, 3) === 'hsl';
      if (useHsl) {
        const parsedStart = parseInt(start.substring(4), 10);
        const parsedEnd = parseInt(end.substring(4), 10);
        const startHue = Number.isNaN(parsedStart) ? 0 : parsedStart;
        const endHue = Number.isNaN(parsedEnd) ? 240 : parsedEnd;

        return getHslColourInRange({
          value,
          maximumValue,
          minimumValue,
          startHue,
          endHue,
        });
      }

      return getColourInRange({
        value,
        maximumValue,
        minimumValue,
        startColour: start || error,
        endColour: end || success,
      });
    },
    isUnset(d) {
      return d.$x === undefined || d.$x === null;
    },
    getMarkerColour(d) {
      const { colouring } = this.settings;

      if (this.kpi && d.$kpi) {
        return this.calculateMarkerColour({
          value: d.$kpi.state,
          minimumValue: this.minimumColourValue,
          maximumValue: this.maximumColourValue,
        });
      }

      if (colouring && colouring.useColour) {
        const { property } = colouring;
        if (property && property.name) {
          return this.calculateMarkerColour({
            value: d[property.name],
            minimumValue: this.minimumColourValue,
            maximumValue: this.maximumColourValue,
          });
        }
      }

      return store.getters[palette].primary;
    },
    render() {
      const { colouring } = this.settings;
      let maximumValue = -Infinity;
      let minimumValue = Infinity;
      if (colouring && colouring.useColour && colouring.property) {
        const { name } = colouring.property;
        this.devices.forEach((d) => {
          if (d[name] > maximumValue) {
            maximumValue = d[name];
          }
          if (d[name] < minimumValue) {
            minimumValue = d[name];
          }
        });
      }

      this.minimumColourValue = minimumValue;
      this.maximumColourValue = maximumValue;

      this.unsetDevices = naturalSort(this.devices
        .filter(this.isUnset)
        .map((d) => ({
          ...d,
          tooltip: this.getDeviceTooltip(d),
          colour: this.getMarkerColour(d),
        })), 'tooltip');

      this.deviceData = this.devices
        .filter((d) => !this.isUnset(d))
        .map((d) => {
          const parsedX = parseFloat(d.$x);
          const parsedY = parseFloat(d.$y);

          const data = {
            ...d,
            $x: parsedX,
            $y: parsedY,
            colour: this.getMarkerColour(d),
          };

          return data;
        })
        .filter((d) => d !== null);
    },
  },
};
